<template>
    <div class="intro">
<!--        弹窗-->
        <el-dialog title="活动规则" :visible.sync="visible" top="10px" width="440px" :before-close="handleClose" :append-to-body="true">
            <el-form ref="form" size="small" :model="form" label-position="top" v-loading="loading">
                <el-form-item label="规则标题：">
                    <el-input v-model="form.title" placeholder="请输入活动规则标题"></el-input>
                </el-form-item>
                <el-form-item label="介绍：" :rules="[{ required: true, message: '请输入活动规则'}]">
                    <Uediter ref="ue" editor_id="ruleEditer" :text="form.content" :config="ueditor.config" @contentChange="contentChangeFunc"></Uediter>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button size="small" type="info" @click="visible = false">取消</el-button>
                <el-button size="small" type="primary"  @click="onSubmit">{{ loading ? "提交中..." : "确 定" }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import Uediter from "@/components/UE.vue";
    import PlatformActivityApi from "@/api/platformactivity.js";
    export default {
        components: {
            Uediter
        },
        props: {
        },
        data() {
            return {
                /*富文本框配置*/
                ueditor: {
                    text: "",
                    config: {
                        initialFrameWidth: 400,
                        initialFrameHeight: 500
                    }
                },
                visible: false,
                loading: false,
                form: {
                    title: "",
                    content: "",
                },
                activity_id: 0
            };
        },
        created() {},
        methods: {
            /*获取富文本内容*/
            contentChangeFunc(e) {
                this.form.content = e;
            },
            getData () {
                this.loading = true
                PlatformActivityApi.activity.rule({
                    activity_id: this.activity_id
                }).then((res) => {
                    this.loading = false
                    if (res.code === 1) {
                        this.form = res.data.detail
                        this.$refs.ue.setUEContent(this.form.content)
                    }
                }).catch((error) => {
                    this.loading = false
                })
            },
            showDialog(activity_id){
                this.activity_id = activity_id
                this.visible = true
                this.getData();
            },
            handleClose(done) {
                this.visible = false
                this.form = {
                    title: "",
                    content: "",
                }
            },
            onSubmit() {
                if(this.loading){
                    return;
                }
                this.loading = true;
                PlatformActivityApi.activity.editRule({
                    activity_id: this.activity_id,
                    title: this.form.title,
                    content: this.form.content,
                }).then((data) => {
                    this.loading = false;
                    this.$message({
                        message: data.msg,
                        type: "success"
                    });
                    this.visible = false
                }).catch((error) => {})
            },

        }
    };
</script>

<style>
#edui_fixedlayer {
    z-index: 9999 !important;
}
.draggable-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
}
.draggable-list .wrapper > span {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
}

.draggable-list .item {
    position: relative;
    width: 110px;
    height: 110px;
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    background: red;
    line-height: 16px;
    font-size: 16px;
    color: #ffffff;
    display: none;
}

.draggable-list .item:hover .delete-btn {
    display: block;
}

.draggable-list .item img {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
}

.draggable-list .img-select {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #dddddd;
    font-size: 30px;
}

.draggable-list .img-select i {
    color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/platformactivity/part/Rule.vue